import {
  createErrorOperationResult,
  createSuccessOperationResult,
} from '@hc-frontend/core-utils-business-operation';
import { createProspectService } from '@hc-frontend/services';

import type { CreateProspectRepository } from '../../domain';

export function createProspectAdapterFactory({
  baseUrl,
}: {
  baseUrl: string;
}): CreateProspectRepository {
  return async (parameters) => {
    try {
      const result = await createProspectService(baseUrl, {
        sessionId: parameters.sessionId,
        userId: parameters.userId,
        landingUrl: parameters.landingUrl,
        landingPage: `http://${parameters.host}/${parameters.source}`,
        tcpaUserAgent: parameters.userAgent,
        ipAddress: parameters.ipAddress,
        src: parameters.source,
      });

      if (result.result === 'success' && result.body) {
        return createSuccessOperationResult(result.body.leadId);
      }

      return createErrorOperationResult({
        errors: [
          {
            code: 'failedToCreateProspect',
            rootCause: new Error(
              `Error creating prospect with sessionId: ${parameters.sessionId} and userId: ${parameters.userId}`,
            ),
          },
        ],
      });
    } catch (error) {
      return createErrorOperationResult({
        errors: [
          {
            code: 'failedToCreateProspect',
            rootCause: error as Error,
          },
        ],
      });
    }
  };
}
